// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"2397f14a","586":"02119f2d"}[chunkId] + ".chunk.js";
};